import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";

const maxItems = 3;

export const inputs = [
  {
    name: "title",
    type: "richText",
    defaultValue:
      "<h3><strong>90-95% reduction</strong> on average in nine toxic substances*<h3>",
    required: true,
  },
  {
    name: "items",
    type: "list",
    required: true,
    subFields: [
      {
        name: "icon",
        type: "file",
        allowedFileTypes: ["svg"],
        required: true,
      },
      {
        name: "title",
        type: "string",
        required: true,
      },
      {
        name: "description",
        type: "longText",
        required: true,
      },
    ],
    defaultValue: [
      {
        icon: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Ff68b2e30a2aa47aeabfc051f24825a20",
        title: "Reduced risk product",
        description:
          "Ploom X is [our latest / an innovative] heated tobacco product which we believe has strong potential as a reduced-risk product compared to smoking cigarettes.",
      },
      {
        icon: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F33a7f1231859407997693fa9f13daa57",
        title: "90-95% reduction",
        description:
          "Ploom X shows, on  average, a 90-95% reduction in the levels of nine constituents recommended by the World Health Organization (WHO) for reduction in cigarette smoke.",
      },
      {
        icon: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F73c78d7e05f34ae2bda918c11080cf68",
        title: "No tobacco product is safe",
        description:
          "This does not mean that use of Ploom X is safe or eliminates health or addiction risks associated with tobacco use. No tobacco product is safe. ",
      },
    ],
    onChange: (options: Map<string, unknown>) => {
      const items = options.get("items");
      if (Array.isArray(items) && items.length > maxItems) {
        options.set("items", items.slice(0, maxItems));
        alert(`You can add maximum ${maxItems} items`);
      }
    },
  },
  {
    name: "backgroundImage",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    required: true,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F1042d12507904b7c8018dedfa28b4dc4",
  },
  {
    name: "mobileBackgroundImage",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F1042d12507904b7c8018dedfa28b4dc4",
  },
  {
    name: "bottomText",
    type: "longText",
    required: false,
  },
] as const satisfies Inputs;

export type ReassuranceBannerBuilderProps = BuilderComponentProps<
  typeof inputs
>;
